// extracted by mini-css-extract-plugin
export default {"input":"simple-otp-input_input__DojN+","wrapper":"simple-otp-input_wrapper__+4b73"};